import React from 'react'

const Impressum = () =>
    <div className="container-fluid mt-2">
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h5>Impressum &amp; Disclaimer</h5>
                    </div>
                    <div className="card-body">
                        <p style={{lineHeight: '2em'}}>Charité - Prodekanat für Studium und Lehre<br />
                        Kontakt zum Team LevelUp Team: levelup@charite.de</p>
                        <br />
                        <p style={{lineHeight: '2em'}}>Siehe auch:<br />
                        Webseite Prodekanat für Studium und Lehre<br />
                        Impressum Charité / ViSdM / Disclaimer</p>
                        <br />
                        <p>Disclaimer:<br /><br />
                        Die Darstellungen innerhalb von LevelUp dienen ausschließlich der Detaildarstellung der Ergebnisse diverser Prüfungen. Es ersetzt nicht die Ergebnismitteilung auf HIS oder korrigiert diese und ist auch nicht als Leistungsnachweis zu verstehen.</p>
                        <p>Diese Rückmeldung basiert auf einem Auszug der Daten. Geringe Abweichungen in den Dezimalen sind möglich.</p>
                        <p>Bei Fragen zu juristischen Einsprüchen zu Prüfungen prüfen Sie bitte die Ergebnisse in HIS und kontaktieren Sie bei Bedarf:</p>
                        <p>Charite – Universitätsmedizin Berlin  — Prüfungsbereich — E-Mail: pruefungen@charite.de</p>
                        <br />
                        <p>Erweiterung:<br /><br />
                        Die in LevelUp abgebildeten Inhalte sind das Ergebnis einer fakultätsweiten Zusammenarbeit. Die Veröffentlichung in der LevelUp dient primär dem Ziel, den Studierenden des Modellstudiengangs Medizin2.0  an der Charité die Informationen zu allen ihren absolvierten summativen und formativen Prüfungsleistungen, sowie Fortschrittsdaten zugänglich zu machen. </p>
                        <br />
                        <p>Jeder Nutzer der LevelUp-Daten ist verpflichtet, die datenschutzrechtlichen Bestimmungen der Charité zu beachten. Dies gilt ausdrücklich auch, wenn eine Genehmigung des Prodekanats für ein Projekt vorliegt. Besondere Vorsicht/Behutsamkeit im Umgang mit Daten ist dann zu treffen, wenn es sich um personengebunde Daten handelt, die Einhaltung der rechtlichen Bestimmungen obliegt dem Nutzer der Daten.</p>
                        <br />
                        <p>Für die Vollständigkeit oder Aktualität der Daten kann das Prodekanat für Studium und Lehre nicht garantieren.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
export default Impressum